/* eslint-disable */
import { create, useStore } from 'zustand';
import { User } from '../types/typeUser';

interface UserStore {
  referralStack: User[];
  setUserOfReferral: (user: User) => void;
  goBackReferral: () => void;
  resetReferrals: () => void;
  currentReferral: User | null;
}

export const usersStore = create<UserStore>((set, get) => ({
  referralStack: [],
  currentReferral: null,

  setUserOfReferral: (user: User) => {
    const { referralStack } = get();
    set({
      referralStack: [...referralStack, user],
      currentReferral: user,
    });
  },

  goBackReferral: () => {
    const { referralStack } = get();
    if (referralStack.length > 1) {
      const newStack = [...referralStack];
      newStack.pop();
      set({
        referralStack: newStack,
        currentReferral: newStack[newStack.length - 1],
      });
    } else {
      set({
        referralStack: [],
        currentReferral: null,
      });
    }
  },

  resetReferrals: () => {
    set({ referralStack: [], currentReferral: null });
  },
}));

export const useUsersStore = () => useStore(usersStore);
